import React from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Paper,
} from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
import AddEditTappingPoints from './../../AddEditTappingPoints/AddEditTappingPoints';

const TappingPointsAddEditPage = () => {
  const location = useLocation();
  const { id } = useParams();
  const isEdit = location.pathname.includes('edit');
  const tappingPointsRef = React.useRef();

  const handleSave = (e) => {
    e.preventDefault();
    tappingPointsRef.current?.submit();
  };

  return (
    <Container sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? "Edit Tapping Point" : "Create New Tapping Point"}
          </Typography>
          <Button
            color="error"
            component={Link}
            to="/tapping-points"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? "Update" : "Create"}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditTappingPoints
            ref={tappingPointsRef}
            isEdit={isEdit}
            selectedId={id}
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default TappingPointsAddEditPage;
